export const coordinatesData = (products, options = {}) => {
  const { checkVariant = false, checkPackingCustomer = false } = options;
  const shapesPerPage = products.reduce((acc, product, index) => {

    const hasValidCoordinates =
      product.product_coordinates &&
      product.product_coordinates.value !== null &&
      product.product_coordinates.valueAlgo !== null;

    if (!hasValidCoordinates) {
      return acc;
    }

    if (product.product_coordinates && product.product_pageNumber) {
      const pageNumber = product.product_pageNumber.value;
      let coordinates =
        product.product_coordinates.value?.map(({ X, Y }) => ({ X, Y })) ||
        [];

      if (coordinates.length === 0) {
        coordinates = [
          { X: 0, Y: 0 },
          { X: 0, Y: 0 },
          { X: 0, Y: 0 },
          { X: 0, Y: 0 },
        ];
      }

      if (coordinates.length >= 4) {
        coordinates[0].X = 0.02; // First point
        coordinates[1].X = 0.98; // Second point
        coordinates[2].X = 0.98; // Third point
        coordinates[3].X = 0.02; // Fourth point
      }

      // Transformation of adjusted coordinates from {X, Y} format to expected [X, Y] format
      coordinates = coordinates.map(({ X, Y }) => [X, Y]);

      if (!acc[pageNumber]) {
        acc[pageNumber] = [];
      }

      const confidences = [
        product.product_id.valueConfidence,
        product.product_quantity.valueConfidence,
        ...(checkVariant ? [product.product_variant_id?.valueConfidence ?? 100] : []),
        ...(checkPackingCustomer ? [product.product_packing_customer?.valueConfidence ?? 100] : []),
      ];

      const hasAnyBelow25 = confidences.some((c) => c < 25);
      const hasAnyBelow75 = confidences.some((c) => c < 75);

      const getStrokeColor = () => {
        if (hasAnyBelow25) return "#ef4444"; // red
        if (hasAnyBelow75) return "#ff9e5a"; // orange
        return "#d6d7d9"; // grey
      };
      const strokeColor = getStrokeColor();

      const strokeWidth = hasAnyBelow75 ? 5 : 0;

      acc[pageNumber].push({
        id: String(index),
        coordinates,
        config: {
          stroke: strokeColor,
          strokeWidth: strokeWidth,
          opacity: "0.6",
        },
      });
    }

    return acc;
  }, {});

  return shapesPerPage;
};
